import TspActionTypes from "./tsp.types";
import { fetchTsp } from "../../services/server-api/server-api.service";

export const fetchTspRequest = () => ({
  type: TspActionTypes.FETCH_TSP_REQUEST,
});

export const fetchTspSuccess = (tspProviders) => ({
  type: TspActionTypes.FETCH_TSP_SUCCESS,
  payload: tspProviders,
});

export const fetchTspFailure = (error) => ({
  type: TspActionTypes.FETCH_TSP_FAILURE,
  payload: error,
});

export const selectTsp = (tsp) => {
  return {
    type: TspActionTypes.SELECT_TSP,
    payload: tsp,
  };
};

export const fetchTspAsync = () => {
  return async (dispatch) => {
    dispatch(fetchTspRequest());
    try {
      const tspProviders = await fetchTsp();
      // konverzija strukture tsp providera radi selecta i odabira defaultne vrijednosti
      const modifiedProviders = tspProviders.map((provider) => {
        return {
          value: provider.tspId,
          name: provider.name,
          label: provider.label,
          signUrl: provider.signUrl,
          userInfoUrl: provider.userInfoUrl,
          internal: provider.internal,
          type: provider.type,
          //tspId: provider.tspId,
        };
      });

            
      dispatch(fetchTspSuccess(modifiedProviders));
      
      const persistTsp = localStorage.getItem("selectedTsp")
        ? JSON.parse(localStorage.getItem("selectedTsp"))
        : null;

      // ovjde mozemo definirati default odabir npr. osobne iskaznice po tsp value 
      // const tspId = persistTsp
      //   ? persistTsp.value
      //   : process.env.REACT_APP_DEFAULT_TSP_ID;

      const foundTsp = modifiedProviders.find((tsp) => tsp.value === persistTsp?.value);
      
      dispatch(selectTsp(foundTsp));
    } catch (error) {
      dispatch(fetchTspFailure({ message: error.message }));
    }
  };
};
